import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useCallback } from "react";
import { Controller, UseFormReturn } from "react-hook-form";

import PrimaryButton from "../../../../../../common/components/primary_button";
import FormContainer from "../../../../../../common/components/form_container";
import {  ReportProvisaoRecursoForm } from "../../../schemas/ProvisaoRecurso/qualidade_provisao_recurso";
import { DefaultDataProvisaoRecurso } from "../../../../../../common/components/default_data_provisao_recurso";


type Props = {
  open: boolean,
  saving: boolean,
  reactHookForm: UseFormReturn<ReportProvisaoRecursoForm>,
  onSubmit: (form: any) => void,
  onClose: () => void,
};

export const ReportModal = ({
  open,
  saving,
  reactHookForm,
  onSubmit,
  onClose,
}: Props) => {
  const handleFormSubmit = (data: any) => {
    const payload = {
      ...data,
      DataPrevista: data.DataPrevista ? data.DataPrevista.toISOString() : null,
      DataRealizada: data.DataRealizada ? data.DataRealizada.toISOString() : null,
    };
    onSubmit(payload);
  };

  const onErrors = (errors: any) => {
    console.error("Erros de validação impedindo o envio:", errors);
  };


  const handleClose = useCallback(() => {
    if (!saving) onClose();
  }, [saving, onClose]);

 return (
    <Dialog
      open={open}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: reactHookForm.handleSubmit(handleFormSubmit, onErrors),
        }
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "40rem",
          },
        },
      }}>
      <DialogTitle>
        Provisão de Recursos
      </DialogTitle>

      <DialogContent>
        <FormContainer title={"Informações"} arrangement="fullRow">
          <div className="flex flex-row gap-4 w-full">
            <div className="flex-1">
              <Controller
                name="DataPrevista"
                control={reactHookForm.control}
                render={({ field: { onChange, value } }) => (
                  <DefaultDataProvisaoRecurso
                    label="Ano Previsto"
                    key="DataPrevista"
                    name="Pesquisar"
                    value={value as any}
                    onChange={onChange}

                  />
                )}
              />
            </div>
            <div className="flex-1">
              <Controller
                name="DataRealizada"
                control={reactHookForm.control}
                render={({ field: { onChange, value } }) => (
                  <DefaultDataProvisaoRecurso
                    key="DataRealizada"
                    label="Ano Realizado"
                    name="Pesquisar"
                    value={value as any}
                    onChange={onChange}
                  />
                )}
              />
            </div>

          </div>
        </FormContainer>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              {saving ? (
                  <PrimaryButton buttonColor="primary-green">
                    Gerando...
                  </PrimaryButton>
                ) : (
                  <PrimaryButton type="submit" buttonColor="primary-green">
                    Gerar
                  </PrimaryButton>
                )
              }
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}